
import React from 'react'

const WhySignUpBox = (props) => {
  
  // console.log("data",data);
  return (
    <div className='whySignUpBox'>
       <span><img src={props.imgSrc} /></span>
       <h5>{props.heading}</h5>
    </div>
  )
}

export default WhySignUpBox
